import { Button } from "antd";

export const PirmaryBtn = ({
  color,
  children,
  className,
  ...restProps
}) => {

  return (
    <Button
      {...restProps}
      className={`${className} text-[var(--xtstarter-primary-button-text-color)] hover:text-[var(--xtstarter-primary-button-text-color)] focus:text-[var(--xtstarter-primary-button-text-color)]`}
      style={{
        '--xtstarter-primary-button-text-color': color,
      }}
    >
      {children}
    </Button>
  )
};